var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[(!_vm.isInline && _vm.enabled)?_c('sidebar'):_vm._e(),_c('div',{staticClass:"flyer-selector-controller",attrs:{"scrollY":_vm.scrollY}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }